import { create } from 'zustand';
import type { SignalPositionOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * signalPositionOverridesDraft — guarda directamente la posición de campo
 * verificada de un semáforo (popup de Modo Edición, "Coordenadas exactas").
 * Guardado real desde 2026-09-10 (antes: export a un snippet que nunca
 * llegaba a pegarse — el motivo original del reporte de Sergi/ARS93, ver
 * ROADMAP.md). Sin estado propio — tras cada escritura se vuelve a pedir
 * `GET /api/overrides` y se aplica sobre `overridesRuntime.ts`.
 */
export type { SignalPositionOverride as SignalPositionOverrideDraft } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  stage: (d: SignalPositionOverride) => Promise<boolean>;
  remove: (id: number) => Promise<boolean>;
}

export const useSignalPositionOverridesDraft = create<DraftState>((set) => ({
  saving: false,
  stage: async (d) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/signal_position/${d.id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  remove: async (id) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/signal_position/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!res.ok && res.status !== 404) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
